import Button from 'components/Button/Button'
import Typography from 'components/Typography/Typography'
import { formatPrice, getFirstDay } from 'utils/helpers'
import { useProfile } from 'utils/hooks/useContext'
import { t } from 'utils/localization'
import iconPlus from 'assets/svg/plus-rooms.svg'
import iconMinus from 'assets/svg/minus.svg'
import { ADMIN, DISTRIBUTOR, PRICE_PER_ROOM } from 'utils/constants'
import {pushDataLayer} from "../../../utils/gtm";
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'

interface BalanceTabProps {}

const BalanceTab = (props: BalanceTabProps) => {
  const profile = useProfile()
  const endDate = getFirstDay();
  const location = useLocation();
  const {state} : any = location;
  useEffect(()=> {
    console.log('check state on mount balance tab', state);
    if (!!state && state.modal) {
      if (state.modal === 'subscription') {
        profile.setShowSubscriptionModal(true)
      }
      delete state.modal;
      window.history.replaceState({...location}, '')
    }
  }, [])
  if (!profile.user) {
    return null;
  }
  const balance = profile.user.cloudData.balance/100 || 0;
  const slotsPaid = profile.user.cloudData.slotsPaid || 0;
  const slotsRenew = profile.user.cloudData.slotsRenew || 0;
  const dueAmount = PRICE_PER_ROOM * slotsRenew;
  const isUserDistributor = profile.user.cloudData.role === DISTRIBUTOR;
  const isUserAdmin = profile.user.cloudData.role === ADMIN;

  const handleDeposit = () => {
    profile.setShowRefillBalanceModal(true)
    pushDataLayer({
      event: "addtocart",
      category: "Users",
      user_id: profile.user?.authData.id,
      origin: window.location.origin,
    });
  }
  
  return (
    <div>
      <Typography weight='semi'>{t('subscription')}</Typography>

      <div className='b-spacer__3' />

      <div className='b-balance'>
        <div className='b-balance__card'>
          <Typography size='xs' color='grey' centered>
            {t('balance')}
          </Typography>
          <Typography size='lg' weight='medium' centered>
            {formatPrice(balance)}
          </Typography>
          <Button
            variant='primary'
            onClick={handleDeposit}
          >
            {t('top-up')}
          </Button>
        </div>

        <div className='b-balance__card'>
          <Typography size='xs' color='grey' centered>
            {t('rooms-number')}
          </Typography>
          <Typography size='lg' weight='medium' centered>
            {slotsRenew} ({slotsPaid}*)
          </Typography>
          {slotsRenew > 0 ? 
            <div className='b-balance__card__controls'>  
              <Button variant='shadow' onClick={() => profile.setShowUnsubscribeRoomsModal(true)}>
                <img src={iconMinus} alt='Decrease rooms subscription' />  
              </Button>
              <Button variant='shadow' onClick={() => profile.setShowSubscriptionModal(true)}>
                <img src={iconPlus} alt='Add rooms subsription' />
              </Button>  
            </div> : 
            <Button
              variant='primary'
              onClick={() => profile.setShowSubscriptionModal(true)}
            >
              {t('subscribe')}
            </Button>
          }
        </div>

        <div className='b-balance__card'>
          <Typography size='xs' color='grey' centered>
            {t('due')} / {endDate}
          </Typography>
          <Typography size='lg' weight='medium' color='error' centered>
            -{formatPrice(dueAmount)}
          </Typography>
        </div>

        <div className='b-balance__card'>
          <Typography size='xs' color='grey' centered>
            {t('balance-next-month')}
          </Typography>
          <Typography size='lg' weight='medium' color={(balance-dueAmount) < 0 ? 'error' : 'black'} centered>
            {formatPrice(balance-dueAmount)}
          </Typography>
        </div>
      </div>
      <div className='b-spacer__2' />
      <Typography size='xs' color='grey'>
          {t('rooms-number-comment')}
      </Typography>
      <div className='b-spacer__4' />
      <div className='b-spacer__4' />
      {(isUserDistributor || isUserAdmin) ? 
        <>
          <Typography weight='semi'>{t('distribution')}</Typography>
          <div className='b-spacer__3' />

          <div className='b-balance'>
            <div className='b-balance__card__wline'>
              <Typography size='xs' color='grey'>
                {t('gift-sub-note')}
              </Typography>
              <div className='b-spacer__2' />
              <Button
                variant='primary'
                onClick={() => profile.setShowShareBalanceModal(true)}
              >
                {t('buy')}
              </Button>
            </div>
          </div>
        </>
       : ''}
    </div>
  )
}

export default BalanceTab
